import React from 'react';
import './MiniAbout.css';

function MiniAbout() {
  return (
    <section className="mini-about">
      <div className="mini-about-inner">

        <span className="mini-about-eyebrow">
          About IHS Engineering
        </span>

        <h2 className="mini-about-title">
          Engineering solutions built on precision, experience, and trust.
        </h2>

        <p className="mini-about-text">
          At IHS Engineering, we deliver innovative, practical engineering solutions
          tailored to the needs of our clients. Our team combines cutting-edge
          technology with deep industry expertise, supporting projects ranging from
          precision machining to large-scale industrial works. With a strong focus on
          quality, sustainability, and efficiency, we are committed to setting the
          standard for engineering excellence across Australia and beyond.
        </p>

      </div>
    </section>
  );
}

export default MiniAbout;
